import * as React from "react";
import Box from "@mui/material/Box";
import Backdrop from "@mui/material/Backdrop";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import SpeedDialAction from "@mui/material/SpeedDialAction";

type ActionType = {
  icon: any;
  name: string;
  action: Function;
};

type SpeedDialTooltipProps = {
  actions: Array<ActionType>;
};

export default function SpeedDialTooltip({ actions }: SpeedDialTooltipProps) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Box
      sx={{
        position: "absolute",
        right: 32,
      }}
    >
      <Backdrop open={open} />
      <SpeedDial
        ariaLabel="SpeedDial tooltip example"
        direction="down"
        sx={{ position: "absolute", right: 0 }}
        icon={<SpeedDialIcon />}
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
      >
        {open &&
          actions.map((action) => (
            <SpeedDialAction
              sx={{
                zIndex: 12000,
                cursor: "pointer",
                whiteSpace: "nowrap",
              }}
              key={action.name}
              icon={action.icon}
              tooltipTitle={action.name}
              tooltipOpen
              onClick={() => {
                action.action();
                handleClose();
              }}
            />
          ))}
      </SpeedDial>
    </Box>
  );
}
